import {NgClass} from '@angular/common';
import {Component, Input, ViewChild} from '@angular/core';
import {KENDO_BUTTONS} from '@progress/kendo-angular-buttons';
import {BaseFilterCellComponent, FilterService} from '@progress/kendo-angular-grid';
import {TextBoxComponent} from '@progress/kendo-angular-inputs';
import {CompositeFilterDescriptor} from '@progress/kendo-data-query';
import {filterClearIcon, SVGIcon} from '@progress/kendo-svg-icons';

//Composant filtre rapide texte
@Component (
{
  selector: 'val-texte-filtre-rapide',
  imports: 
  [
    NgClass,
    KENDO_BUTTONS,
    TextBoxComponent
  ],
  templateUrl: './texte-filtre-rapide.component.html',
  styleUrl: './texte-filtre-rapide.component.scss',
})
export class TexteFiltreRapideComponent extends BaseFilterCellComponent 
{
  //Création
  //  Paramètres
  //    filterService : Service filtre
  constructor (filterService: FilterService) 
  {
    super (filterService);

    this.boutonEffacerVisible = false;
    this.boutonEffacerIcone = filterClearIcon;
    this.valeur = "";
  }

  //Editeur
  @ViewChild ("editeurTexte")
  public editeurTexte!: TextBoxComponent;

  //Indique si le bouton effacer est visible
  public boutonEffacerVisible: boolean;

  //Icone du bouton effacer
  public boutonEffacerIcone: SVGIcon;

  //Description des filtres
  @Input()
  public override filter!: CompositeFilterDescriptor;

  //Nom du champ
  @Input ()
  public nomChamp!: string;

  //Valeur
  public valeur: string;

  //Retourne la valeur sélectionnée
  public get selectedValue () : any 
  {
    const filter = this.filterByField (this.nomChamp);

    return filter ? filter.value : null;
  }

  //Après l’initialisation du contenu
  public override ngAfterContentInit() : void 
  {
    const filter = this.filterByField (this.nomChamp);

    if (filter)
    {
      this.valeur = filter.value;
      this.boutonEffacerVisible = true;
    }
  }

  //Change la valeur du filtre
  public ChangerValeurFiltre () 
  {
    if (this.valeur === "")
      this.applyFilter (this.removeFilter (this.nomChamp));
    else
    {
      this.applyFilter (this.updateFilter (
                      {
                        field: this.nomChamp,
                        operator: "contains",
                        value: this.valeur
                      })
      );
    }

    if (this.valeur !== "")
      this.boutonEffacerVisible = true;
  }

  //Traite la fermeture de la popup
  public TraiterFermeturePopUp () : void 
  {
    setTimeout (() => {this.editeurTexte.blur ();}, 50);
  }

  //Efface l’éditeur
  public Effacer () : void 
  {
    this.valeur = "";

    this.applyFilter (this.removeFilter (this.nomChamp));

    this.boutonEffacerVisible = false;
  }

  //Traite le clavier
  //  Paramètres
  //    evenementClavier : Données de l’événement clavier
  public TraiterClavier (evenementClavier: KeyboardEvent) : void 
  {
    if (evenementClavier.key === "Enter")
      this.ChangerValeurFiltre ();
  }
}
